import { post } from 'services/api';
import { DefaultValues } from './types';

export const requestPassword = (values: DefaultValues) =>
	post('/public/users/forgot-password', {
		email: values.email,
	});
